/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MarketGoogleStoreProductInfoRequest model module.
 * @module model/MarketGoogleStoreProductInfoRequest
 * @version 1.0
 */
class MarketGoogleStoreProductInfoRequest {
    /**
     * Constructs a new <code>MarketGoogleStoreProductInfoRequest</code>.
     * @alias module:model/MarketGoogleStoreProductInfoRequest
     */
    constructor() { 
        
        MarketGoogleStoreProductInfoRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>MarketGoogleStoreProductInfoRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MarketGoogleStoreProductInfoRequest} obj Optional instance to populate.
     * @return {module:model/MarketGoogleStoreProductInfoRequest} The populated <code>MarketGoogleStoreProductInfoRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MarketGoogleStoreProductInfoRequest();

            if (data.hasOwnProperty('productNo')) {
                obj['productNo'] = ApiClient.convertToType(data['productNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MarketGoogleStoreProductInfoRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MarketGoogleStoreProductInfoRequest</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} productNo
 */
MarketGoogleStoreProductInfoRequest.prototype['productNo'] = undefined;






export default MarketGoogleStoreProductInfoRequest;

